<template>
  <div class="question-wrap">
    <div class="question-outer">
      <div class="countdown">{{ countdown }}s</div>
      <div class="question-inner">
        <div class="question">
          {{ question }}
        </div>
        <div class="answers">
          <van-row
            type="flex"
            align="center"
            v-for="(value, key) in answers"
            :key="key"
            :class="[
              'answer-item',
              loading
                ? key === selectedAnswer
                  ? 'selected'
                  : ''
                : key === rightAnswer
                ? 'true'
                : key === selectedAnswer
                ? 'false'
                : '',
            ]"
            @click="handleSelected(key)"
          >
            <van-col span="3"></van-col>
            <van-col span="18" style="text-align: center">{{ value }}</van-col>
            <van-col span="3" style="text-align: center">
              <template v-if="!loading">
                <van-icon v-if="key === rightAnswer" name="success" size="20" />
                <van-icon
                  v-else-if="key === selectedAnswer"
                  name="cross"
                  size="20"
                />
              </template>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="progress">{{ index + 1 }}/5</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    index: {
      type: [Number, String],
      default: "",
    },
    id: {
      type: String,
      require: true,
    },
    question: {
      type: String,
      require: true,
    },
    answers: {
      type: Array,
      require: true,
    },
    sign: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      // 倒计时计时器
      timer: 0,
      // 倒计时
      countdown: 30,
      // 选择或者倒计时为0时为true
      isStop: false,
      // 用户选择的答案
      selectedAnswer: "",
      //正确答案
      rightAnswer: "",
      // 答题loading
      loading: false,

      answerMap: ["A", "B", "C", "D"],
    };
  },
  methods: {
    // 选择答案
    handleSelected(key) {
      this.checkAnswer(key);
    },
    /**
     * 校验答案
     */
    async checkAnswer(answer = "") {
      if (this.isStop) {
        return;
      }
      // if (this.countdown > 27) {
      //   this.$notify({
      //     type: "warning",
      //     message: "请阅题3秒后再进行作答",
      //     duration: 2000,
      //   });
      //   return;
      // }
      clearInterval(this.timer);
      this.selectedAnswer = answer;
      this.isStop = true;
      try {
        this.loading = true;
        // 校验答案是否正确
        const res = await this.$axios.post(`/Question/verifyAnswer`, {
          questionId: this.id,
          answer:
            this.selectedAnswer !== ""
              ? this.answerMap[Number(this.selectedAnswer)]
              : "",
          id: this.$store.state.user?.user.id,
          sign: this.sign,
        });
        console.log("校验答案结果：", res);
        this.rightAnswer = this.answerMap.indexOf(String(res.data.correct));
        this.$emit("end");
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "答题超时，请返回首页重新参与竞赛",
          duration: 2000,
        });
        this.$router.replace("/");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.countdown <= 0) {
        this.checkAnswer();
        return;
      }
      this.countdown--;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.question-wrap {
  .question-outer {
    position: relative;
    padding-top: 39px;
    background: #fff;
    border: 2px solid #000;
    border-radius: 6px;
    .countdown {
      position: absolute;
      top: -27px;
      right: 0;
      left: 0;
      width: 53px;
      height: 53px;
      margin: auto;
      font-size: 27px;
      font-weight: 600;
      line-height: 53px;
      color: #fed24c;
      text-align: center;
      background: #fff;
      border: 2px solid;
      border-radius: 50%;
      box-shadow: 0 2px 11px 0 rgba(249, 120, 30, 0.6);
    }
    .question-inner {
      max-height: 484px;
      overflow: auto;
      .question {
        padding: 0 34px 23px;
        font-size: 17px;
        font-weight: bold;
        line-height: 24px;
        color: #140661;
      }
      .answers {
        // max-height: 325px;
        padding: 0 34px;
        overflow-y: scroll;
        .answer-item {
          padding: 14px 18px;
          margin-bottom: 20px;
          font-size: 17px;
          line-height: 22px;
          color: #000;
          background-color: #edf4ff;
          border-radius: 13px;
          &.selected {
            color: $white;
            background-color: $button-blue-color;
          }
          &.true {
            color: $white;
            background-color: $button-green-color;
          }
          &.false {
            color: $white;
            background-color: $button-red-color;
          }
          .van-icon {
            vertical-align: top;
          }
        }
      }
    }
    .progress {
      padding: 7px 0 13px 20px;
      font-size: 15px;
      line-height: 25px;
      color: #999;
    }
  }
}
</style>
